// frontend/src/pages/home/HomePageNavbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { icons } from '../../assets';
import '../../styles/Home/HomePage.css';
import '../../styles/Dashboard/dashboardStyle.css';
import { TryFreeButton } from '../../components/TryFreeButton';
import { NotificationsModal } from '../../components/modals/NotificationsModal';
import { GetPremiumModal } from '../../components/modals/GetPremiumModal';
import { SidebarModal } from '../../components/modals/SidebarModal';
import { FeedbackModal } from '../../components/modals/FeedbackModal';
import { logout } from '../../redux/actions/UserActions';

export const HomePageNavbar = ({ darkMode, title, saveInterests }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isNotificationsModalVisible, setNotificationsModalVisible] = useState(false);
  const [isPremiumModalVisible, setPremiumModalVisible] = useState(false);
  const [isProfileDropdownVisible, setProfileDropdownVisible] = useState(false);
  const [isSupportDropdownVisible, setSupportDropdownVisible] = useState(false);
  const [isSidebarModalVisible, setSidebarModalVisible] = useState(false);
  const [isFeedbackModalVisible, setFeedbackModalVisible] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetails = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null;

  const handleProfileClick = () => navigate(`/profile/${userDetails.id}`);
  const handleSupportClick = () => setSupportDropdownVisible(v => !v);
  const handleFeedbackClick = () => setFeedbackModalVisible(true);
  const handleGetPremiumClick = () => {
    setProfileDropdownVisible(false);
    setPremiumModalVisible(true);
  };
  const handleLogout = async () => await dispatch(logout(navigate));

  // close dropdowns & mobile menu when clicking outside
  const profileDropdownRef = useRef(null);
  useEffect(() => {
    const onClickOutside = e => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(e.target)
      ) {
        setProfileDropdownVisible(false);
        setSupportDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  // lock scroll when any modal is open
  useEffect(() => {
    if (
      isSidebarModalVisible ||
      isNotificationsModalVisible ||
      isPremiumModalVisible ||
      isFeedbackModalVisible
    ) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [
    isSidebarModalVisible,
    isNotificationsModalVisible,
    isPremiumModalVisible,
    isFeedbackModalVisible
  ]);

  const navLinks = [
    // { to: '/dashboard', label: 'Dashboard' },
    // { to: '/sports/gameSchedule/basketball?sport=basketball&league=NBA', label: 'NBA' },
    // { to: '/sports/gameSchedule/football?sport=football&league=NFL', label: 'NFL' },
    // { to: '/sports/gameSchedule/mma?sport=mma&league=UFC', label: 'UFC' },
    // { to: '/sports', label: 'Other Sports' }

    { to: '/', label: 'Dashboard' },
    { to: '/', label: 'NBA' },
    { to: '/', label: 'NFL' },
    { to: '/', label: 'UFC' },
    { to: '/', label: 'Other Sports' }
  ];

  return (
    <nav className={`home-navbar ${darkMode ? 'dark-nav' : 'light-nav'}`}>
      <div className="navbar-logo">
        <Link to="/">
          <img
            src={darkMode ? icons.bigLogoLight : icons.bigLogoDark}
            alt="Logo"
          />
        </Link>
      </div>

      {/* desktop links */}
      <ul className="navbar-links">
        {navLinks.map(({ to, label }) => (
          <li key={to}>
            <Link className="nav-item" to={to}>
              {label}
            </Link>
          </li>
        ))}

        {!userDetails ? (
          <>
            <li>
              <Link to="/register" className="nav-item sign-up-btn">
                Sign Up
              </Link>
            </li>
            <li>
              <button
                className="nav-item login-btn"
                onClick={() => navigate('/login')}
              >
                Login
              </button>
            </li>
          </>
        ) : (
          <li className="profile-wrapper" ref={profileDropdownRef}>
            <button
              className="profile-trigger"
              onClick={() => setProfileDropdownVisible(v => !v)}
            >
              <img
                className="icon-size"
                loading="lazy"
                src={userDetails.profileImg || icons.defaultProfile}
                alt="Profile"
              />
            </button>
            {isProfileDropdownVisible && (
              <div className="profile-dropdown">
                <button onClick={handleProfileClick}>Profile</button>
                <button onClick={handleSupportClick}>Support</button>
                <button onClick={handleGetPremiumClick}>Get Premium</button>
                <button onClick={handleLogout}>Log Out</button>
              </div>
            )}
            {isSupportDropdownVisible && (
              <div className="support-dropdown">
                <a href="https://app.termly.io/document/terms-of-service/…">Terms of Service</a>
                <a href="https://app.termly.io/document/privacy-policy/…">Privacy Policy</a>
                <button onClick={handleFeedbackClick}>Feedback</button>
              </div>
            )}
          </li>
        )}
      </ul>

      {/* hamburger */}
      <button
        className="navbar-burger"
        aria-label="Toggle menu"
        onClick={() => setMenuOpen(open => !open)}
      >
        <span className={menuOpen ? 'open' : ''}></span>
        <span className={menuOpen ? 'open' : ''}></span>
        <span className={menuOpen ? 'open' : ''}></span>
      </button>

      {/* mobile menu overlay */}
      <div
        className={`mobile-menu ${menuOpen ? 'show' : ''}`}
        onClick={e => {
          // close if clicking on backdrop
          if (e.target.classList.contains('mobile-menu')) {
            setMenuOpen(false);
          }
        }}
      >
        {/* explicit close button */}
        <button
          className="mobile-menu-close"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        >
          ×
        </button>

        <ul>
          {navLinks.map(({ to, label }) => (
            <li key={to} onClick={() => setMenuOpen(false)}>
              <Link className="nav-item" to={to}>
                {label}
              </Link>
            </li>
          ))}

          {!userDetails ? (
            <>
              <li onClick={() => setMenuOpen(false)}>
                <Link className="nav-item" to="/register">
                  Sign Up
                </Link>
              </li>
              <li
                onClick={() => {
                  setMenuOpen(false);
                  navigate('/login');
                }}
              >
                <button className="nav-item">Login</button>
              </li>
            </>
          ) : (
            <li>
              <button
                className="nav-item"
                onClick={() => {
                  setMenuOpen(false);
                  handleProfileClick();
                }}
              >
                Profile
              </button>
              <button className="nav-item" onClick={handleSupportClick}>
                Support
              </button>
              <button className="nav-item" onClick={handleGetPremiumClick}>
                Get Premium
              </button>
              <button className="nav-item" onClick={handleLogout}>
                Log Out
              </button>
            </li>
          )}
        </ul>
      </div>

      {/* modals */}
      <NotificationsModal
        isVisible={isNotificationsModalVisible}
        onClose={() => setNotificationsModalVisible(false)}
      />
      <GetPremiumModal
        isVisible={isPremiumModalVisible}
        onClose={() => setPremiumModalVisible(false)}
      />
      {isSidebarModalVisible && (
        <SidebarModal onClose={() => setSidebarModalVisible(false)} />
      )}
      <FeedbackModal
        isVisible={isFeedbackModalVisible}
        onClose={() => setFeedbackModalVisible(false)}
      />
    </nav>
  );
};
